import React from "react";
import {
  Backdrop,
  Box,
  CircularProgress,
  FormControl,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import {
  getListUser,
  getReportRevenue,
  getUserAccessAccount,
} from "../service";
import { AxiosResponse } from "axios";
// react-apexcharts removed - package not installed
import dayjs from "dayjs";
import { DataGrid } from "@mui/x-data-grid";
import { formatMoney } from "utils/format-money";

const style = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  p: 2,
  bgcolor: "white",
  gap: 4,
};
const styleRow = {
  display: "flex",
  flexDirection: "column",
  maxWidth: 300,
  width: "100%",
  gap: 1,
  py: 1,
  px: 2,
  borderWidth: 1,
  borderStyle: "solid",
  borderColor: "#dedede",
  borderRadius: 1,
  boxShadow: "2px 4px 8px #edf2ef",
};

const ReportRevenue = () => {
  const [listData, setListData] = React.useState([]);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [totalPrice, setTotalPrice] = React.useState<any>(0);
  const [typePrice, setTypePrice] = React.useState<any>(0);
  const [totalRow, setTotalRow] = React.useState<any>();
  const [currentType, setCurrentType] = React.useState<string>("All forms");
  const [currentPage, setCurrentPage] = React.useState<number>(1);
  const [userAccessCount, setUserAccessCount] = React.useState<number>(0);
  const [studentCount, setStudentCount] = React.useState<any>(0);

  React.useEffect(() => {
    initData();
  }, [currentType, currentPage]);

  React.useEffect(() => {
    getAccessAccount();
    getTotalUser();
  }, []);

  const initData = React.useCallback(() => {
    setLoading(true);
    getReportRevenue({
      status: "success",
      order_by: "DESC",
      type: currentType === "All forms" ? "" : currentType,
      page: currentPage,
      limit: 10,
    }).then((res) => {
      setLoading(false);
      setListData(res.data);
      setTotalPrice(res.headers?.["x-total-price"]);
      setTypePrice(res.headers?.["x-total-price"]);
      setTotalRow(res.headers?.["x-total-count"]);
    });
  }, [currentType, currentPage]);

  const getAccessAccount = () => {
    setLoading(true);
    getUserAccessAccount().then((res) => {
      setLoading(false);
      setUserAccessCount(res.data?.access_count);
    });
  };
  const getTotalUser = () => {
    setLoading(true);
    getListUser({ limit: 1, page: 1 }).then((res) => {
      setLoading(false);
      setStudentCount(res.headers?.["x-total-count"]);
    });
  };

  const columns = [
    {
      field: "Student",
      headerName: "Khóa học",
      width: 650,
      renderCell: (params) => {
        return (
          <Stack mt={2}>
            <Typography>{params.row?.items[0]?.service_name}</Typography>
          </Stack>
        );
      },
    },
    {
      field: "user_id",
      headerName: "Người mua",
      width: 200,
      renderCell: (params) => {
        return (
          <Stack mt={2}>
            <Typography>{params.row?.user_id?.display_name}</Typography>
          </Stack>
        );
      },
    },
    {
      field: "categories",
      headerName: "Hình thức",
      width: 150,
      renderCell: (params) => {
        return (
          <Stack mt={2}>
            <Typography>{params.row?.type}</Typography>
          </Stack>
        );
      },
    },
    {
      field: "price",
      headerName: "Giá",
      width: 200,
      renderCell: (params) => {
        return (
          <Stack mt={2}>
            <Typography>{formatMoney(params.row?.price)}đ</Typography>
          </Stack>
        );
      },
    },
    {
      field: "date",
      headerName: "Date",
      width: 120,
      renderCell: (params) => {
        return (
          <Stack mt={2}>
            <Typography>
              {dayjs(params.row?.billing_on).format("DD/MM/YYYY")}
            </Typography>
          </Stack>
        );
      },
    },
  ];

  return (
    <Box sx={style}>
      <Backdrop
        open={loading}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        flexWrap={"wrap"}
        gap={4}
      >
        <Box sx={styleRow}>
          <Typography color="success" variant="body1">
            Tổng doanh thu
          </Typography>
          <Typography sx={{ fontWeight: "bold" }}>
            {formatMoney(totalPrice)}đ
          </Typography>
        </Box>
        <Box sx={styleRow}>
          <Typography color="error" variant="body1">
            Số lượng học viên
          </Typography>
          <Typography sx={{ fontWeight: "bold" }}>{studentCount}</Typography>
        </Box>
        <Box sx={styleRow}>
          <Typography color="secondary" variant="body1">
            Lượng truy cập ứng dụng
          </Typography>
          <Typography sx={{ fontWeight: "bold" }}>{userAccessCount}</Typography>
        </Box>
        <Box sx={styleRow}>
          <Typography color="primary" variant="body1">
            Số khóa học đã mua
          </Typography>
          <Typography sx={{ fontWeight: "bold" }}>{totalRow}</Typography>
        </Box>
        <Box sx={styleRow}>
          <Typography color="primary" variant="body1">
            Doanh thu: {currentType}
          </Typography>
          <Typography sx={{ fontWeight: "bold" }}>
            {formatMoney(typePrice)}đ
          </Typography>
        </Box>
      </Stack>
      <Stack gap={1}>
        <Box>
          <FormControl sx={{ width: "100%" }}>
            <Select
              size="small"
              value={currentType ?? ""}
              sx={{
                maxWidth: 150,
                width: "100%",
                p: 1,
              }}
              onChange={(event) => {
                setCurrentType(event.target.value);
              }}
            >
              <MenuItem value="All forms">All forms</MenuItem>
              <MenuItem value="Call group">Call group</MenuItem>
              <MenuItem value="Call 1-1">Call 1-1</MenuItem>
              <MenuItem value="Self-learning">Self-learning</MenuItem>
              <MenuItem value="Offline">Offline</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <DataGrid
          rows={listData}
          columns={columns}
          rowCount={totalRow}
          paginationMode="server"
          initialState={{
            pagination: {
              paginationModel: { page: currentPage - 1, pageSize: 10 },
            },
          }}
          onPaginationModelChange={(paginationModel) => {
            setCurrentPage(paginationModel.page + 1);
          }}
          pageSizeOptions={[5, 10]}
          getRowId={(row) => row._id}
          localeText={{ noRowsLabel: "Không có kết quả khi lọc" }}
          sx={{
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
            },
          }}
        />
      </Stack>
    </Box>
  );
};

export default ReportRevenue;
